import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { ROUTES } from "../common/constants";
import { useAuth } from "../contexts/AuthContext";

export function Shell() {
  const { admin, logout } = useAuth();
  const navigate = useNavigate();

  async function signOut() {
    await logout();
    navigate(ROUTES.LOGIN, { replace: true });
  }

  return (
    <div className="admin-shell">
      <header className="admin-head">
        <div className="admin-head-inner">
          <Link to={ROUTES.PAGE_EDITOR("home")} className="admin-brand">
            Quintara <span>CMS</span>
          </Link>
          <nav className="admin-nav">
            <NavLink to={ROUTES.PAGES}>Pages</NavLink>
            {admin?.role === "admin" && <NavLink to={ROUTES.TEAM}>Team</NavLink>}
          </nav>
          <div className="admin-user">
            <span className="admin-user-name">
              {admin?.display_name || admin?.username}
              <span className="admin-user-role"> · {admin?.role}</span>
            </span>
            <button type="button" className="btn-ghost" onClick={signOut}>
              Sign out
            </button>
          </div>
        </div>
      </header>
      <main className="admin-main">
        <Outlet />
      </main>
    </div>
  );
}
